'use strict';

import defaultTemplate from '../../core/default.html';
import orgsListTemplate from './list/organizations.list.html';
import orgsNewTemplate from './organizations.new.html';
import orgsTemplateTemplate from './organizations.template.html';

import Organizations from './organizations.ctrl';

function OrganizationsRouter($urlRouterProvider, $stateProvider) {
  $stateProvider
    .state('main.organizations', {
      url: '/organizations',
      template: defaultTemplate
    })
    .state('main.organizations.list', {
      url: '/list',
      template: orgsListTemplate,
      controller: 'OrganizationsListController as vm',
      resolve: {
        permission: ($q, utils, PermissionsService) => {
          return PermissionsService.canIViewOrganizationList()
            ? $q.resolve()
            : $q.reject('Route permission check failed: main.organizations.list');
        }
      }
    })
    .state('main.organizations.new', {
      url: '/new',
      template: orgsNewTemplate,
      controller: 'OrganizationsNewController as vm',
      resolve: {
        permission: ($q, utils, PermissionsService) => {
          return PermissionsService.canICreateOrganization()
            ? $q.resolve()
            : $q.reject('Route permission check failed: main.organizations.new');
        }
      }
    })
    .state('main.organizations.template', {
      url: '/template?:name',
      template: orgsTemplateTemplate,
      controller: 'OrganizationsTemplateController as vm'
    });
}

export default angular
  .module('organizations.router', [
    Organizations
  ])
  .config(OrganizationsRouter)
  .name;
